import { defineComponent } from "vue";
import { mapState } from "pinia";
import { Container } from "aurelia-dependency-injection";

import { useHospiceConvertToPending } from "../../../store/useHospiceConvertToPending";
import { formatZipCode, formatPhoneNumber } from "../../../../../../common/vue-helpers/modifiers/value-modifier";
import { PharmacyService } from "../../../../../../services/pharmacy.service";
import { ITypeaheadOptions } from "../../../../../../resources-vue/vue-interfaces/i-typeahead";
import { IPharmacySlim } from "../../../../../../resources-vue/vue-interfaces/i-get-pharmacy";
import { IPharmacy } from "../../../../../../resources-vue/vue-interfaces/i-pharmacy";
import { Pharmacy } from "../../../../../../resources-vue/vue-models/pharmacy";

import TypeaheadInput from "../../../../../../resources-vue/vue-custom-elements/TypeaheadInput/TypeaheadInput.vue";
import FormatName from "../../../../../../resources-vue/vue-custom-elements/FormatName/FormatName.vue";

export default defineComponent({
    components: {
        TypeaheadInput,
        FormatName
    },
    props: {
        pharmacyId: { type: String, default: "" },
        providerId: { type: String, default: "" }
    },
    data() {
        return {
            loadingPharmacyDetails: false,
            pharmacy: null as ITypeaheadOptions,
            pharmacyDetails: new Pharmacy(),
            _ignoreIdChange: false,
            _pharmacyService: null,
            formatZipCode,
            formatPhoneNumber
        };
    },
    computed: {
        ...mapState(useHospiceConvertToPending, ["accountId", "patientDetails", "application"])
    },
    watch: {
        async pharmacy(newValue: ITypeaheadOptions) {
            if (newValue) {
                let pharmacyId = newValue.value;
                this._ignoreIdChange = true;
                this.$emit("updatePharmacyId", pharmacyId);
                await this.loadPharmacyData(pharmacyId);
            } else {
                this.pharmacy = null;
                this.pharmacyDetails = null;
                this.loadingPharmacyDetails = false;
            }
        }
    },
    emits: ["updatePharmacyId"],
    created() {
        this._pharmacyService = Container.instance.get(PharmacyService);
    },
    async mounted() {
        if (this.pharmacyId) {
            await this.pharmacyIdChanged(this.pharmacyId);
        }
    },
    methods: {
        async getPharmacyList(filter: string, limit: number) {
            let pharmaciesResult = await this._pharmacyService.getPharmacyByName({
                term: filter,
                page: 1,
                pageLength: 10,
                providerIds: [this.providerId],
                agencyId: this.accountId,
                application: this.application
            });
            if (pharmaciesResult.data.length > 0) {
                return this.pharmacySlimToTypeahead(pharmaciesResult.data);
            } else {
                return [];
            }
        },
        pharmacyChanged(data: ITypeaheadOptions) {
            this.pharmacy = data;
        },
        async loadPharmacyData(pharmacyId: string) {
            if (pharmacyId) {
                this.loadingPharmacyDetails = true;
                this.pharmacyDetails = await this._pharmacyService.getPharmacyById({
                    id: pharmacyId,
                    accountId: this.accountId,
                    application: this.application
                });
                this.loadingPharmacyDetails = false;
            }
        },
        pharmacySlimToTypeahead(pharmacies: IPharmacySlim[]) {
            return pharmacies.map((pharmacy: IPharmacySlim) => ({
                name: pharmacy.displayName,
                value: pharmacy.pharmacyId
            }));
        },
        async pharmacyIdChanged(pharmacy: string) {
            if (this._ignoreIdChange) {
                this._ignoreIdChange = false;
                return;
            }
            if (pharmacy) {
                await this.loadPharmacyData(pharmacy);
                this.pharmacy = {
                    name: this.pharmacyDetails.Name,
                    value: this.pharmacyDetails.Id
                };
            } else {
                this.pharmacy = null;
                this.pharmacyDetails = null;
                this.loadingPharmacyDetails = false;
            }
        }
    }
});
